import { render, staticRenderFns } from "./RelatorioJulgamento.vue?vue&type=template&id=0c605a88"
import script from "./RelatorioJulgamento.vue?vue&type=script&lang=js"
export * from "./RelatorioJulgamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports